import { render } from "./MarketingGeneral.vue?vue&type=template&id=5794e95e&scoped=true"
import script from "./MarketingGeneral.vue?vue&type=script&lang=js"
export * from "./MarketingGeneral.vue?vue&type=script&lang=js"

import "./MarketingGeneral.vue?vue&type=style&index=0&id=5794e95e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5794e95e"]])

export default __exports__